import { createAction } from 'typesafe-actions';
import { IParentModal } from '@types';

export const setESIGNPOPUPSTATUS = createAction('SET_ESIGNPOPUPSTATUS', (esignPopUpState: string) => esignPopUpState)();

export const setESIGNDISCLOSEDACTIVEUSER = createAction(
    'setESIGNDISCLOSEDACTIVEUSER',
    (selctedDisclosureUser: string) => selctedDisclosureUser
)();

export const setParentModal = createAction('SET_PARENT', (payload: IParentModal) => payload)();
